const searchObjectByProperty = (array, value, prop) =>{
  if(!value)
    return {
      componentID: '',
      shortTerm: '',
      longTerm: ''
    }

  var result  = array.filter(function(o){return o[prop] == value;} );
 
  return result.length? result[0] : {
    componentID: '',
    shortTerm: '',
    longTerm: ''
  }; // or empty
}



class EventDispatcher {
  constructor() {
    this.listeners = {}
  }
  
  // Füge einen Event Listener hinzu
  addEventListener(event, listener) {
    if (!this.listeners[event]) {
      this.listeners[event] = []
    }
    this.listeners[event].push(listener)
  }
  
  // Entferne einen Event Listener
  removeEventListener(event, listener) {
    if (!this.listeners[event]) return
    this.listeners[event] = this.listeners[event].filter(l => l !== listener)
  }
  
  // Löse ein Ereignis aus
  dispatchEvent(event, data) {
    if (!this.listeners[event]) return
    this.listeners[event].forEach(listener => listener(data))
  }
}

const beautifier = (value, code= "de-DE", digits= 2) => {
  return Number(value).toLocaleString(code, {minimumFractionDigits: digits, maximumFractionDigits: digits});
}

const formatStr2Number = (str) => {
  var number = Number(str.toString().replace(',','.'));
  if (isNaN(number)) number = 0;
  return number;
};

const replaceArrayElement = (array, pos, value) => {
  array.splice(pos, 1, value);
  return array;
}


const getParameterByName = (name) => {
  //eslint-disable-next-line
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}



export {
    searchObjectByProperty,
    formatStr2Number,
    beautifier,
    replaceArrayElement,
    getParameterByName,
    EventDispatcher
}